// Catalogue review (Phase 7): a product a partner adds (or prices up too far) waits for Ops review
// and stays hidden from customers until approved. AdminProduct carries reviewStatus / reviewNote
// (docs/PHASE7-CONTRACT.md, "Ops · Catalogue rules"); a missing status means approved.

/** @typedef {import('@popcart/core/v1').AdminProduct} AdminProduct */
/** @typedef {'approved' | 'pending' | 'rejected'} ReviewStatus */
/** AdminProduct with the Phase 7 review fields (optional until the core type carries them). @typedef {{ reviewStatus?: ReviewStatus | null; reviewNote?: string | null }} ReviewFields */

/**
 * @param {ReviewFields | null | undefined} p
 * @returns {{ status: ReviewStatus; note: string | null }}
 */
export function reviewOf(p) {
  const s = p?.reviewStatus;
  const status = s === 'pending' || s === 'rejected' ? s : 'approved';
  const note = typeof p?.reviewNote === 'string' && p.reviewNote.trim() ? p.reviewNote.trim() : null;
  return { status, note };
}

/**
 * The badge for the list and the editor, or null when approved.
 * @param {ReviewFields | null | undefined} p
 * @returns {{ label: string; tone: 'warning' | 'error' } | null}
 */
export function reviewBadge(p) {
  const { status, note } = reviewOf(p);
  if (status === 'pending') return { label: 'In review', tone: 'warning' };
  if (status === 'rejected') return { label: note ? `Not approved: ${note}` : 'Not approved', tone: 'error' };
  return null;
}

/**
 * The editor's explanation under the badge, or null when approved.
 * @param {ReviewFields | null | undefined} p
 */
export function reviewExplainer(p) {
  const { status } = reviewOf(p);
  if (status === 'pending') return 'PopCart checks new products and big price changes before customers see them. This one is waiting; you can keep editing it.';
  if (status === 'rejected') return 'PopCart didn’t approve this product, so customers can’t see it. Check the note above; PopCart can approve it once it’s fixed.';
  return null;
}
